import detailStyles from '../ChallengeDetail.module.scss';
import image161 from './images/16-1.jpg';
import image162 from './images/16-2.jpg';
import image163 from './images/16-3.jpg';
import { ChallengeDetailHelpImage } from './ChallengeDetailHelpImage';

export const BuyBoostDescription = () => {
    return (
        <div className={detailStyles.description}>
            <p>
                <div>
                    Перейдите в раздел <b>«Активы»</b>
                </div>
                <ChallengeDetailHelpImage image={image161} helpText='Это картинка. Ищите меню разделов в игре.' />
            </p>

            <p>
                <div>
                    Зайдите в подраздел <b>«Усиления»</b>
                </div>
                <ChallengeDetailHelpImage image={image162} helpText='Это картинка. Ищите подраздер в разделе «Активы».' />
            </p>
            
            <p>
                <div>
                    Купите усиление
                </div>
                <ChallengeDetailHelpImage image={image163} helpText='Это картинка. Ищите кнопку в подразделе «Усиления».' />
            </p>
        </div>
    );
}